import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { guaranteeItems } from "../../data/landing";
export function Guarantee() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-171" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-dashed border-gold bg-white p-6 text-center sm:p-10" data-id="element-172" data-mp="24l3tnaur47le">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-navy text-gold" data-id="element-173" data-mp="2ed00baawl618">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-174" data-mp="2jbl23e5szxrs" />
          <span className="mt-0.5 text-xs font-extrabold uppercase tracking-wider" data-id="element-175" data-mp="2jdxkttjdyc5w">7 days</span>
        </div>
        <p className="mt-5 text-sm font-bold uppercase tracking-[0.14em] text-gold-dark" data-id="element-176" data-mp="2scsnwwr4v64z">7-day guarantee</p>
        <h2 className="mt-2 font-serif text-[1.8rem] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-177" data-mp="txg0m9og43ya">
          Explore Lipo Planning Workbook™ without unnecessary risk
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-178" data-mp="3slg91eqm18xv">
          Open the system, explore the framework and decide whether it fits your professional learning process. You have 7 days to:
        </p>
        <ul className="mx-auto mt-6 grid max-w-xl gap-2.5 text-left sm:grid-cols-2" data-id="element-179" data-mp="3ivdhliz5031n">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-2.5 text-[16px] font-medium text-ink" data-id="element-180" data-mp="3dxlf5v0v8yj7">
              <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-181" data-mp="fdvbbfz0j43c" />
              {g}
            </li>)}
        </ul>
        <p className="mt-6 text-[15px] leading-relaxed text-navy/70" data-id="element-182" data-mp="adqrph2t5t8w">
          If you decide the system isn't useful for your professional education, contact us within the guarantee period according to
          the purchase terms. You'll be eligible for a refund under the stated guarantee conditions.
        </p>
        <div className="mt-8" data-id="element-183" data-mp="2l7uzhhjl5okz">
          <CtaButton label="Try Lipo Planning Workbook™ for 7 days" data-id="element-184" data-mp="2l7ligjgiqrrf" />
        </div>
      </div>
    </section>;
}